import { classImplementsInterfaces } from "@goodgamestudios/createjs-utilities";

import { BasicInitServerCommands } from "@goodgamestudios/core";
import { SFConstants } from "../../constants/SFConstants";
import { LCACommand } from "../commands/account/LCACommand";
import { LCPCommand } from "../commands/account/LCPCommand";
import { LGNCommand } from "../commands/account/LGNCommand";
import { LLPCommand } from "../commands/account/LLPCommand";
import { LPNCommand } from "../commands/account/LPNCommand";
import { LRECommand } from "../commands/account/LRECommand";
import { SOECommand } from "../commands/account/SOECommand";
import { ALICommand } from "../commands/achievement/ALICommand";
import { ARECommand } from "../commands/achievement/ARECommand";
import { BEXCommand } from "../commands/bonusevents/BEXCommand";
import { SPBCommand } from "../commands/bonusevents/SPBCommand";
import { SPTCommand } from "../commands/bonusevents/SPTCommand";
import { BBUCommand } from "../commands/booster/BBUCommand";
import { BGACommand } from "../commands/buddy/BGACommand";
import { BIGCommand } from "../commands/buddy/BIGCommand";
import { BOSCommand } from "../commands/buddy/BOSCommand";
import { CIFCommand } from "../commands/buddy/CIFCommand";
import { CJFCommand } from "../commands/buddy/CJFCommand";
import { SBSCommand } from "../commands/buddy/SBSCommand";
import { GACCommand } from "../commands/game/GACCommand";
import { GAFCommand } from "../commands/game/GAFCommand";
import { GBOCommand } from "../commands/game/GBOCommand";
import { GBRCommand } from "../commands/game/GBRCommand";
import { GBSCommand } from "../commands/game/GBSCommand";
import { GENCommand } from "../commands/game/GENCommand";
import { GGGCommand } from "../commands/game/GGGCommand";
import { GHCCommand } from "../commands/game/GHCCommand";
import { GLUCommand } from "../commands/game/GLUCommand";
import { GNRCommand } from "../commands/game/GNRCommand";
import { GPACommand } from "../commands/game/GPACommand";
import { GPJCommand } from "../commands/game/GPJCommand";
import { GPLCommand } from "../commands/game/GPLCommand";
import { GPTCommand } from "../commands/game/GPTCommand";
import { GRBCommand } from "../commands/game/GRBCommand";
import { GRHCommand } from "../commands/game/GRHCommand";
import { GRPCommand } from "../commands/game/GRPCommand";
import { GRSCommand } from "../commands/game/GRSCommand";
import { GSDCommand } from "../commands/game/GSDCommand";
import { GSICommand } from "../commands/game/GSICommand";
import { GSTCommand } from "../commands/game/GSTCommand";
import { GSUCommand } from "../commands/game/GSUCommand";
import { GYTCommand } from "../commands/game/GYTCommand";
import { TCHCommand } from "../commands/game/TCHCommand";
import { TCRCommand } from "../commands/lobby/TCRCommand";
import { TJNCommand } from "../commands/lobby/TJNCommand";
import { TLICommand } from "../commands/lobby/TLICommand";
import { RAACommand } from "../commands/ranking/RAACommand";
import { RALCommand } from "../commands/ranking/RALCommand";
import { RHFCommand } from "../commands/ranking/RHFCommand";
import { RJLCommand } from "../commands/ranking/RJLCommand";
import { RTACommand } from "../commands/ranking/RTACommand";
import { CPUCommand } from "../commands/servermessage/CPUCommand";
import { EMCCommand } from "../commands/servermessage/EMCCommand";
import { EMVCommand } from "../commands/servermessage/EMVCommand";
import { SEECommand } from "../commands/servermessage/SEECommand";
import { VCKCommand } from "../commands/servermessage/VCKCommand";
import { IVWCommand } from "../commands/shop/IVWCommand";
import { SBUCommand } from "../commands/shop/SBUCommand";
import { SENCommand } from "../commands/sitngo/SENCommand";
import { SINCommand } from "../commands/sitngo/SINCommand";
import { SJNCommand } from "../commands/sitngo/SJNCommand";
import { SLICommand } from "../commands/sitngo/SLICommand";
import { SRECommand } from "../commands/sitngo/SRECommand";
import { SSBCommand } from "../commands/sitngo/SSBCommand";
import { SSPCommand } from "../commands/sitngo/SSPCommand";
import { SURCommand } from "../commands/sitngo/SURCommand";
import { SZOCommand } from "../commands/sitngo/SZOCommand";
import { SSMCommand } from "../commands/slotmaschine/SSMCommand";
import { FSTCommand } from "../commands/teaser/FSTCommand";
import { JENCommand } from "../commands/tournament/JENCommand";
import { JIOCommand } from "../commands/tournament/JIOCommand";
import { JJICommand } from "../commands/tournament/JJICommand";
import { JJNCommand } from "../commands/tournament/JJNCommand";
import { JLICommand } from "../commands/tournament/JLICommand";
import { JNXCommand } from "../commands/tournament/JNXCommand";
import { JRBCommand } from "../commands/tournament/JRBCommand";
import { JRECommand } from "../commands/tournament/JRECommand";
import { JSBCommand } from "../commands/tournament/JSBCommand";
import { JTECommand } from "../commands/tournament/JTECommand";
import { JTJCommand } from "../commands/tournament/JTJCommand";
import { JTSCommand } from "../commands/tournament/JTSCommand";
import { JURCommand } from "../commands/tournament/JURCommand";
import { JZOCommand } from "../commands/tournament/JZOCommand";
import { TSTCommand } from "../commands/tutorial/TSTCommand";
import { TTSCommand } from "../commands/tutorial/TTSCommand";
import { BRPCommand } from "../commands/userdata/BRPCommand";
import { GBDCommand } from "../commands/userdata/GBDCommand";
import { GCUCommand } from "../commands/userdata/GCUCommand";
import { GDBCommand } from "../commands/userdata/GDBCommand";
import { GPCCommand } from "../commands/userdata/GPCCommand";
import { GPICommand } from "../commands/userdata/GPICommand";
import { GPPCommand } from "../commands/userdata/GPPCommand";
import { GPVCommand } from "../commands/userdata/GPVCommand";
import { GXPCommand } from "../commands/userdata/GXPCommand";
import { LVUCommand } from "../commands/userdata/LVUCommand";
import { VGCCommand } from "../commands/various/VGCCommand";
import {LGNPreCommand} from "../commands/account/LGNPreCommand";
import { CASPreCommand } from "../commands/account/CASPreCommand";

export class Poker2InitServerCommandsCommand extends BasicInitServerCommands {
    public execute(commandVars: any = null): void {
        super.execute();
        //servermessages
        this.commandDict.set("vck", new VCKCommand());

        //account
        this.commandDict.set("lca", new LCACommand());
        this.commandDict.set("lcp", new LCPCommand());
        this.commandDict.set(SFConstants.S2C_SOCIAL_LOGIN, new LGNPreCommand());
        this.commandDict.set("lgn", new LGNCommand());
        this.commandDict.set("lre", new LRECommand());
        this.commandDict.set("llp", new LLPCommand());
        this.commandDict.set("lpn", new LPNCommand());
        this.commandDict.set("soe", new SOECommand());
        this.commandDict.set("cas", new CASPreCommand());

        this.commandDict.set("gcu", new GCUCommand());
        this.commandDict.set("gpi", new GPICommand());
        this.commandDict.set("gpc", new GPCCommand());

        //userdata
        this.commandDict.set("gbd", new GBDCommand());
        this.commandDict.set("gxp", new GXPCommand());
        this.commandDict.set("gpv", new GPVCommand());
        this.commandDict.set("gpp", new GPPCommand());
        this.commandDict.set("gdb", new GDBCommand());
        this.commandDict.set("lvu", new LVUCommand());
        this.commandDict.set("brp", new BRPCommand());

        //lobby
        this.commandDict.set("tli", new TLICommand());
        this.commandDict.set("tjn", new TJNCommand());
        this.commandDict.set("tcr", new TCRCommand());

        //shop
        this.commandDict.set("sbu", new SBUCommand());
        this.commandDict.set("ivw", new IVWCommand());

        //game
        this.commandDict.set("gsi", new GSICommand());
        this.commandDict.set("glu", new GLUCommand());
        this.commandDict.set("gpj", new GPJCommand());
        this.commandDict.set("gpl", new GPLCommand());
        this.commandDict.set("gac", new GACCommand());
        this.commandDict.set("gst", new GSTCommand());
        this.commandDict.set("gpa", new GPACommand());
        this.commandDict.set("gsd", new GSDCommand());
        this.commandDict.set("gyt", new GYTCommand());
        this.commandDict.set("gpt", new GPTCommand());
        this.commandDict.set("gen", new GENCommand());
        this.commandDict.set("gnr", new GNRCommand());
        this.commandDict.set("ghc", new GHCCommand());
        this.commandDict.set("ggg", new GGGCommand());
        this.commandDict.set("tch", new TCHCommand());
        this.commandDict.set("gaf", new GAFCommand());
        this.commandDict.set("grs", new GRSCommand());
        this.commandDict.set("gsu", new GSUCommand());
        this.commandDict.set("gbs", new GBSCommand());
        this.commandDict.set("gbo", new GBOCommand());
        this.commandDict.set("gbr", new GBRCommand());
        this.commandDict.set("grp", new GRPCommand());
        this.commandDict.set("grb", new GRBCommand());
        this.commandDict.set("grh", new GRHCommand());

        //tournament/joust
        this.commandDict.set("jli", new JLICommand());
        this.commandDict.set("jre", new JRECommand());
        this.commandDict.set("jts", new JTSCommand());
        this.commandDict.set("jtj", new JTJCommand());
        this.commandDict.set("jjn", new JJNCommand());
        this.commandDict.set("jur", new JURCommand());
        this.commandDict.set("jji", new JJICommand());
        this.commandDict.set("jnx", new JNXCommand());
        this.commandDict.set("jen", new JENCommand());
        this.commandDict.set("jzo", new JZOCommand());
        this.commandDict.set("jsb", new JSBCommand());
        this.commandDict.set("jte", new JTECommand());
        this.commandDict.set("jio", new JIOCommand());
        this.commandDict.set("jrb", new JRBCommand());

        //sit n Go
        this.commandDict.set("sli", new SLICommand());
        this.commandDict.set("sre", new SRECommand());
        this.commandDict.set("sjn", new SJNCommand());
        this.commandDict.set("szo", new SZOCommand());
        this.commandDict.set("sen", new SENCommand());
        this.commandDict.set("sur", new SURCommand());
        this.commandDict.set("ssb", new SSBCommand());
        this.commandDict.set("sin", new SINCommand());
        this.commandDict.set("ssp", new SSPCommand());

        //booster
        this.commandDict.set("bbu", new BBUCommand());

        //ranking
        this.commandDict.set("ral", new RALCommand());
        this.commandDict.set("rjl", new RJLCommand());
        this.commandDict.set("rhf", new RHFCommand());
        this.commandDict.set("raa", new RAACommand());
        this.commandDict.set("rta", new RTACommand());
        //achievement
        this.commandDict.set("are", new ARECommand());
        this.commandDict.set("ali", new ALICommand());
        //various
        this.commandDict.set("vgc", new VGCCommand());
        //emailverifizierung
        this.commandDict.set("emv", new EMVCommand());
        this.commandDict.set("emc", new EMCCommand());
        // buddy
        this.commandDict.set("sbs", new SBSCommand());
        this.commandDict.set("bga", new BGACommand());
        this.commandDict.set("big", new BIGCommand());
        this.commandDict.set("cjf", new CJFCommand());
        this.commandDict.set("cif", new CIFCommand());
        this.commandDict.set("bos", new BOSCommand());
        // events
        this.commandDict.set("see", new SEECommand());
        this.commandDict.set("cpu", new CPUCommand());
        // tutorial
        this.commandDict.set("tts", new TTSCommand());
        this.commandDict.set("tst", new TSTCommand());
        //teaser
        this.commandDict.set("fst", new FSTCommand());
        // bonus 2x XP for 24h after registration
        this.commandDict.set(SFConstants.S2C_BONUS_EVENT_XP, new BEXCommand());
        this.commandDict.set("ssm", new SSMCommand());
        this.commandDict.set(SFConstants.S2C_STARTER_PACKAGE_TEASER, new SPTCommand());
        this.commandDict.set(SFConstants.S2C_BOUGHT_STARTER_PACKAGE, new SPBCommand());
    }
}
classImplementsInterfaces(Poker2InitServerCommandsCommand, "ISimpleCommand");
